import { api } from "@/lib/api";

const DEFAULTS = [
  { id: "default-champions", key: "champions", name: "Formula Champions", color: "#00E5FF", sort_order: 0 },
  { id: "default-elite",     key: "elite",     name: "Formula Elite",     color: "#FF3B30", sort_order: 1 },
];

let cache = null;
let pending = null;
const listeners = new Set();

export function getCachedSplits() {
  return cache || DEFAULTS;
}

export function fetchSplits(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (pending) return pending;
  pending = api.get("/splits")
    .then(({ data }) => {
      cache = Array.isArray(data) && data.length ? data : DEFAULTS;
      listeners.forEach((cb) => cb(cache));
      return cache;
    })
    .catch(() => {
      cache = DEFAULTS;
      return cache;
    })
    .finally(() => { pending = null; });
  return pending;
}

export function subscribeSplits(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function invalidateSplits(newSplits) {
  if (Array.isArray(newSplits) && newSplits.length) {
    cache = newSplits;
    listeners.forEach((cb) => cb(cache));
  } else {
    cache = null;
    fetchSplits(true);
  }
}

export function findSplit(key, list = null) {
  const arr = list || cache || DEFAULTS;
  return arr.find((s) => s.key === key) || arr[0] || DEFAULTS[0];
}
